module.exports = "<h1>Drag & drop</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dragdrop/dragdrop.template.html
// module id = ./src/app/dragdrop/dragdrop.template.html
// module chunks = main